import { render, staticRenderFns } from "./AnonymiseCustomerModal.vue?vue&type=template&id=1af535d8"
import script from "./AnonymiseCustomerModal.vue?vue&type=script&lang=js"
export * from "./AnonymiseCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports